import { getTransactionHistory } from 'redux/transaction-history/saga/fetchTransactionHistory';
import { onQueryTransaction } from 'redux/transaction-history/saga/queryTransaction';
import { onQueryMultiTransaction } from 'redux/transaction-history/saga/queryMultipleTransactions';
import { onExportTransactionData } from 'redux/transaction-history/saga/exportTransactionData';

import { call, all } from 'redux-saga/effects';

export default function* groupsSaga() {
  yield all([
    call(getTransactionHistory),
    call(onQueryTransaction),
    call(onQueryMultiTransaction),
    call(onExportTransactionData),
  ]);
}
